import React, { useState, useEffect } from "react";
import { CARD_STYLE, CHART_CONTAINER_STYLE } from "../../../../constants/styles";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTimes, faUser } from "@fortawesome/free-solid-svg-icons";

import UserScoreBySurvey from "./UserScoreBySurvey";
import UserAvgCompletionTime from "./UserAvgCompletionTime";
import UserResponsesTable from "./UserResponsesTable";
import UserBehaviourPanel from "./UserBehaviourPanel";

export default function UserAnalyticsModal({ user, onClose, showModal }) {

	
	
	const [displayThis, setDisplayThis] = useState("none");
	
	
	useEffect(function () {
		
	    if (showModal === true) {
	        setDisplayThis("flex");
	    }
	    else {
	        setDisplayThis("none");
	    }
	}, [showModal]);
	
	if (!user) {
        return null;
    }
	

    const overlayStyle = {
		display:displayThis,
        position: "fixed",
        top: 0,
        left: 0,
        width: "100vw",
        height: "100vh",
        backgroundColor: "rgba(0,0,0,0.55)",
        zIndex: 999999,
        justifyContent: "center",
        alignItems: "center"
    };

    const modalStyle = {
        width: "95%",
        height: "92%",
        backgroundColor: "#f4f6f9",
        borderRadius: "16px",
        display: "flex",
        flexDirection: "column",
        overflow: "hidden",
        boxShadow: "0 20px 60px rgba(0,0,0,0.4)"
    };

    const headerStyle = {
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        padding: "16px 24px",
        background: "linear-gradient(135deg, #111, #1d1d1d)",
        color: "#fff"
    };

    const bodyStyle = {
        flex: 1,
        overflow: "auto",
        padding: "24px"
    };

    const cardHeader = {
        fontSize: "12px",
        fontWeight: "bold",
        marginBottom: "8px"
    };

    return (
        <div style={overlayStyle}>
            <div style={modalStyle}>

                {/* Header */}
                <div style={headerStyle}>
                    <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                        <FontAwesomeIcon icon={faUser} />
                        <span>{user.name} – User Analytics</span>
                    </div>
                    <FontAwesomeIcon
                        icon={faTimes}
                        style={{ cursor: "pointer" }}
                        onClick={onClose}
                    />
                </div>

                {/* Body */}
                <div style={bodyStyle}>

                    {/* Top KPIs */}
                    <div style={{ display: "flex", gap: "20px", marginBottom: "20px" }}>

					<div style={{ ...CARD_STYLE, width: "220px", height: "180px", flexDirection: "column" }}>
                            <div style={cardHeader}>Avg Completion Time</div>
                            <div style={CHART_CONTAINER_STYLE}>
                                <UserAvgCompletionTime user={user} />
                            </div>
                        </div>

                        <div style={{ ...CARD_STYLE, flex: 1, height: "180px", flexDirection: "column" }}>
                            <div style={cardHeader}>Score by Questionnaire</div>
                            <div style={CHART_CONTAINER_STYLE}>
                                <UserScoreBySurvey user={user} />
                            </div>
                        </div>

                        

                    </div>

                    {/* Responses Table */}
                    <div style={{ ...CARD_STYLE, width: "100%", marginBottom: "20px", flexDirection: "column" }}>
                        <div style={cardHeader}>User Responses</div>
                        <div style={CHART_CONTAINER_STYLE}>
                            <UserResponsesTable user={user} />
                        </div>
                    </div>

                    {/* Behaviour Panel */}
                    <div style={{ ...CARD_STYLE, width: "100%", flexDirection: "column" }}>
                        <div style={cardHeader}>User Behaviour & Deviations</div>
                        <div style={CHART_CONTAINER_STYLE}>
                            <UserBehaviourPanel user={user} />
                        </div>
                    </div>

                </div>
            </div>
        </div>
    );
}
